export default __webpack_public_path__ + "static/media/element_88.a8d164a3.jpg";